import React, { useState } from 'react'
import shortid from 'shortid'

import Button from '@react/react-spectrum/Button'
import Select from '@react/react-spectrum/Select'
import { Table, THead, TBody, TH, TR, TD } from '@react/react-spectrum/Table'
import Textfield from '@react/react-spectrum/Textfield'

import Delete from '@react/react-spectrum/Icon/Delete'

const EVENTS = [{ label: 'Page loaded', value: 'pageLoad' }, { label: 'Element clicked', value: 'click' }]
const CONDITION_PLACEHOLDERS = { pageLoad: 'URL pattern', click: 'CSS selector' }
const ACTIONS = [
  { label: 'Add to Cart', value: 'addToCart' },
  { label: 'Login', value: 'login' },
  { label: 'Product View', value: 'productView' },
  { label: 'Registration', value: 'registration' },
  { label: 'Search', value: 'search' },
]

const EmptyState = () => (
  <div className='pvs-emptyState'>
    <p>No rules</p>
  </div>
)

const addIds = arr => (Array.isArray(arr) ? arr.map(p => ({ ...p, id: shortid() })) : [])

const Editor = ({ properties, disabled, onSave }) => {
  const [entries, setEntries] = useState(addIds(properties))
  const hasEntries = Array.isArray(entries) && entries.length > 0

  const addEntry = () => {
    setEntries(entries => [...entries, { id: shortid() }])
  }

  const deleteEntry = id =>
    setEntries(entries => {
      const newEntries = entries.filter(e => e.id !== id)
      onSave(newEntries)
      return newEntries
    })

  const onFieldChange = (name, id) => value => {
    setEntries(entries => {
      const newEntries = entries.map(e => (e.id === id ? { ...e, [name]: value } : e))
      onSave(newEntries)
      return newEntries
    })
  }

  return (
    <div className='rules-editor'>
      {hasEntries && (
        <Table className='rules-table'>
          <THead>
            <TH>Event</TH>
            <TH>Condition</TH>
            <TH>Action</TH>
            <TH width='60' className='pvs-actions'></TH>
          </THead>
          <TBody>
            {entries.map(entry => (
              <TR key={entry.id}>
                <TD>
                  <Select
                    options={EVENTS}
                    defaultValue={entry.event || ''}
                    placeholder='Select an event'
                    onChange={onFieldChange('event', entry.id)}
                    disabled={disabled}
                  />
                </TD>
                <TD>
                  <Textfield
                    name='condition'
                    defaultValue={entry.condition || ''}
                    placeholder={CONDITION_PLACEHOLDERS[entry.event] || 'Condition'}
                    onChange={onFieldChange('condition', entry.id)}
                    disabled={disabled}
                  />
                </TD>
                <TD>
                  <Select
                    options={ACTIONS}
                    defaultValue={entry.action || ''}
                    placeholder='Select a rule to trigger'
                    onChange={onFieldChange('action', entry.id)}
                    disabled={disabled}
                  />
                </TD>
                <TD>
                  <Button
                    variant='tool'
                    aria-label='Delete'
                    icon={<Delete />}
                    onClick={() => deleteEntry(entry.id)}
                    disabled={disabled}
                  />
                </TD>
              </TR>
            ))}
          </TBody>
        </Table>
      )}

      {!hasEntries && <EmptyState />}

      <Button label='Add Rule' className='rules-add-button' variant='primary' onClick={addEntry} disabled={disabled} />
    </div>
  )
}

export default Editor
